<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.goodsissue') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.customer')"
              :subtitle="$t('series.gi')+' ' + nextGiCode"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.storecompanyperson') }}</label>
                    <selectize
                      v-model="form.pickedCustomerId"
                      :default="form.defaultCustomerId"
                      :updateoption="form.updateOptionCustomer"
                      :options="form.optionCustomers"
                      :multiple="false"
                      :create="true"
                      :loading="form.loadingCustomer"
                      :validation="form.trickValidationCustomer"
                      :placeholder="$t('placeholder.selectorcreate')"
                      @add="onAddedCustomer"/>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="form.pickedCustomerId"
              class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <textarea
                      v-model="form.customer.address"
                      class="form-control"
                      style="min-height: 107px;"/>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      v-model="form.customer.tel"
                      type="text"
                      class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      v-model="form.customer.email"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.date')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('apps.inventory.message.deliverydate') }}</label>
                    <BaseInputDatePicker
                      v-model="form.selectedDate"
                      mode="dateTime"
                      is24hr
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.inventory.message.pickfrom')"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.store') }}</label>
                    <select
                      v-model="form.pickedWarehouseId"
                      class="form-control custom-select">
                      <option
                        v-for="(item, index) in warehouses"
                        v-if="item.is_deleted == false"
                        :key="index"
                        :value="item.warehouse_id">
                        {{ item.warehouse_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.orderlist')"/>
            <OrderGI
              v-if="isRenderOrders"
              :validation="form.trickValidation"
              :data="form.orders"
              :createAble="true"
              :showProductImage="true"
              :selectedWhId="form.pickedWarehouseId"
              :optionBinLocations="optionBinLocations"
              @submit="onSubmitOrder"
            />
          </div>
        </section>

        <section>
          <div class="col-md-12 no-padding">
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('placeholder.note') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.note"
                      class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-web"
              @click="form.trickValidation++;isCreateAnother = false">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-web"
              disabled><i class="fas fa-spinner spin"/></button>
          </div>
        </section>
      </template>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'
import moment from 'moment'

export default {
  name: 'GoodsIssueNew',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedWarehouseId: null,
        pickedCustomerId: null,
        defaultCustomerId: null,
        optionCustomers: [],
        trickValidationCustomer: 0,
        customer: {
          address: null,
          email: null,
          tel: null,
        },
        updateOptionCustomer: null,
        loadingCustomer: false,
        note: '',
        selectedDate: moment().toDate(),
        trickValidation: 0,
        orders: [],
      },

      originalForm: null,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      isRenderOrders: true,
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      customer: 'getCustomer',
      customers: 'getCustomers',
      nextGiCode: 'getNextGiCode',
      getMainWarehouse: 'getMainWarehouse',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      getMainStock: 'getMainStock',
      getWarehouseInfo: 'getWarehouseInfo',
      dateformat: 'getDateFormat',
      getCustomerById: 'getCustomerById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
    }),
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    optionWarehouses () {
      const items = this.warehouses.map((item) => {
        return {
          text: item.warehouse_name,
          value: item.warehouse_id,
        }
      })
      return items
    },
    optionBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseId) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
  },
  watch: {
    ready: function (isReady) {
      if (isReady) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 4,
        submenuAtIdx: 1,
      })
    },
    async 'form.pickedWarehouseId' (after, before) {
      // get next gicode
      await this.$store.dispatch('getNextGiCode', {
        warehouse_id: this.form.pickedWarehouseId,
        short_name: this.getWarehouseInfo(this.form.pickedWarehouseId).short_name,
      })
      // loading finish
      this.showFinish(this.$Progress)

      this.isRenderOrders = false
      this.form.orders = []
      setTimeout(() => this.isRenderOrders = true, 10)
    },
    customers: function (after, before) {
      this.form.optionCustomers = []
      for (let i in after) {
        let customer = after[i]
        this.form.optionCustomers.push({
          text: customer.customer_name,
          value: customer.customer_id,
        })
      }
    },
    'form.pickedCustomerId': {
      handler: function (after) {
        let customer_id = after
        let customerInfo = this.getCustomerById(customer_id)

        this.form.customer.address = null
        this.form.customer.email = null
        this.form.customer.tel = null

        if (customerInfo) {
          this.form.customer.address = customerInfo.address
          this.form.customer.email = this.getPartnerContact(customerInfo.contacts).email
          this.form.customer.tel = this.getPartnerContact(customerInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    // set date format
    this.formats.input = [this.dateformat + ' HH:mm:ss']
    this.formats.dayPopover = this.dateformat + ' HH:mm:ss'
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
    // get customers
    await this.$store.dispatch('getCustomers')
    // set default
    this.setData()
    // ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 5,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 4,
      submenuAtIdx: 1,
    })
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearCustomer', 'clearCustomers', 'clearProducts'])
  },
  methods: {
    async onAddedCustomer (value) {
      // show loading selectize
      this.form.loadingCustomer = true

      // insert new customer
      let res = await this.$store.dispatch('insertCustomer', { name: value })

      if (res.success) {
        let customer = res.data
        // update option value
        this.form.updateOptionCustomer = {
          text: value,
          value: customer.customer_id,
          picked: true,
        }
        this.form.optionCustomers.push({
          text: value,
          value: customer.customer_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingCustomer = false
      }
    },
    async clearForm () {
      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      // get next gicode
      await this.$store.dispatch('getNextGiCode', {
        warehouse_id: this.getMainWarehouse.warehouse_id,
        short_name: this.getMainWarehouse.short_name,
      })

      this.ready = true

      // scroll to top
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    },
    onSubmitOrder (isValid, data) {
      this.form.trickValidationCustomer++

      let isInValid = !isValid || (this.form.pickedCustomerId == null || this.form.pickedCustomerId == '')

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.save(data)
    },
    async save (data) {
      var orders = []

      for (let i in data) {
        let order = data[i]
        var getSku = this.getSkuInfoBySkuId(order.sku_id)
        var stocks

        if (!getSku) {
          let resGetProduct = await this.$store.dispatch('getProduct', {
            sku_id: order.sku_id,
          })
          let product = resGetProduct.data[0]
          let sku = product.prices.find(sku => sku.sku_id == order.sku_id)
          stocks = sku.stocks
        } else {
          stocks = getSku.stocks
        }

        let stock = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseId)

        const newOrder = {
          'sku_id': order.sku_id,
          'item': order.item,
          'quantity': order.quantity,
          'stock_id': stock.stock_id,
          'warehouse_id': stock.warehouse_id,
          'bin_location_id': order.bin_location_id,
        }

        if (order.lot.selected.length) {
          newOrder.lot_numbers = order.lot.selected.map((item) => {
            return {
              'lot_id': item.lotId,
              'lot_code': item.lotCode,
              'bin_location_id': item.binId,
              'unit': Number(item.unit),
            }
          })
        }

        if (order.serial.selected.length) {
          newOrder.serial_numbers = order.serial.selected.map((item) => {
            return {
              'bin_location_id': item.binId,
              'ser_id': item.serId,
              'ser_code': item.serCode,
              'serial_number': item.serialNumber,
            }
          })
        }

        orders.push(newOrder)
      }

      let dataSet = {
      	orders: orders,
      	stockout: {
      		warehouse_id: this.form.pickedWarehouseId,
      		short_name: this.getWarehouseInfo(this.form.pickedWarehouseId).short_name,
      	},
      	note: this.form.note.trim().length > 0 ? this.form.note.trim() : null,
      	po_id: null,
        customer_id: this.form.pickedCustomerId,
        scheduled_at: this.form.selectedDate ? this.form.selectedDate.toISOString() : this.moment().toISOString(),
      }

      // update customer
      let dataSetCustomerUpdate = this.getDataSetPartnerUpdate('customer', this.form.pickedCustomerId, this.form.customer, this.customers)
      if (dataSetCustomerUpdate !== null) {
        await this.$store.dispatch('updateCustomer', dataSetCustomerUpdate)
        await this.$store.dispatch('getCustomers')
      }

      // save data
      var res = await this.$store.dispatch('insertGoodsissue', dataSet)

      if (res.success) {
        let newGoodsIssue = res.data.goodsissue

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newGoodsIssue.gi_code }),
          color: 'success',
          icon: 'cloud',
        })

        if (!this.isCreateAnother) {
          // go to GoodsIssueAll page
          return this.$router.push({
            name: 'GoodsIssueEdit',
            query: {
              gi_id: newGoodsIssue._id,
              gi_code: newGoodsIssue.gi_code,
              ignoreDiscardAlert: true,
            },
          })
        } else {
          this.clearForm()
        }
      }
    },
    async setData () {
      // set picked main warehouse id
      this.form.pickedWarehouseId = this.getMainWarehouse.warehouse_id
      // set originalForm
      this.originalForm = _.cloneDeep(this.form)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodsissue/New.vue